/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Role_DieticianInputs */

const en_coaches_page_role_dietician = /** @type {(inputs: Coaches_Page_Role_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietician`)
};

const pl_coaches_page_role_dietician = /** @type {(inputs: Coaches_Page_Role_DieticianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dietetyk`)
};

/**
* | output |
* | --- |
* | "Dietician" |
*
* @param {Coaches_Page_Role_DieticianInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_role_dietician = /** @type {((inputs?: Coaches_Page_Role_DieticianInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Role_DieticianInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_role_dietician(inputs)
	return en_coaches_page_role_dietician(inputs)
});